import { createAxiosInstance } from 'common/utils/axios'

// Endpoint
import { AUTH_ENDPOINTS, AUTH_SERVICE_URL } from 'common/constants/apiUrls'
import QueryString from 'qs'
import axios from 'axios'

export const authAxiosLocalServer = createAxiosInstance(AUTH_SERVICE_URL)

const handler = authAxiosLocalServer

export const Login = async ({ username, password }) => {
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      Accept: 'application/x-www-form-urlencoded',
    },
    data: QueryString.stringify({
      email: username,
      password,
    }),
    url: AUTH_SERVICE_URL + AUTH_ENDPOINTS.LOGIN,
    withCredentials: true,
  }
  const response = await axios(options)

  const { data } = response.data
  // Adding expiry date to credentials
  // const expDate = new Date()
  // expDate.setHours(expDate.getHours() + 8)

  const dataWithExpDate = {
    ...data,
    // expiry: expDate,
  }
  return dataWithExpDate
}
export const LoginTwoFa = async ({ auth_hash }) => {
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      Accept: 'application/x-www-form-urlencoded',
    },
    url: AUTH_SERVICE_URL + AUTH_ENDPOINTS.LOGIN_TWOFA + auth_hash,
    withCredentials: true,
  }
  const response = await axios(options)

  const { data } = response
  // Adding expiry date to credentials
  const expDate = new Date()
  expDate.setHours(expDate.getHours() + 8)

  const dataWithExpDate = {
    ...data,
    expiry: expDate,
  }
  return dataWithExpDate
}

export const GenerateIntegrationToken = async ({ label, scopes, allowed_ips, expires }) => {
  let allowedIPs = []
  if (allowed_ips) {
    allowedIPs = allowed_ips?.split(',')
  }
  const response = await handler.post(AUTH_ENDPOINTS.GENERATE_INTEGRATION_TOKEN, {
    label,
    scopes,
    allowed_ips: allowedIPs,
    expires,
  })

  const { data } = response.data

  return data
}

export const ListIntegrationToken = async () => {
  const response = await handler.get(AUTH_ENDPOINTS.LIST_INTEGRATION_TOKENS)
  const { data } = response.data
  return data
}
export const RevokeIntegrationToken = async ({ jti }) => {
  const response = await handler.post(AUTH_ENDPOINTS.REVOKE_INTEGRATION_TOKEN, { jti })
  const { data } = response.data
  return data
}
export const RotateIntegrationToken = async ({ token }) => {
  const response = await handler.post(AUTH_ENDPOINTS.ROTATE_INTEGRATION_TOKEN, { token })
  const { data } = response.data
  return data
}
